<template>
  <el-form
    label-width="100px"
    :inline="true"
    :model="form"
    class="demo-form-inline"
  >
    <el-form-item label="标题" required>
      <el-input v-model="form.title" clearable />
    </el-form-item>

    <el-form-item label="排序" required>
      <el-input v-model="form.sort" clearable />
    </el-form-item>
    <el-form-item label="分类" prop="is_event">
      <el-select v-model="form.is_event" placeholder="请选择分类" clearable>
        <el-option
          v-for="item in eventStatusEnum"
          :label="item.label"
          :key="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item label="折扣" required>
      <el-input v-model="form.discount" clearable />
    </el-form-item>
    <el-form-item label="结束时间" required>
      <el-date-picker
        v-model="form.end_time"
        type="datetime"
        value-format="YYYY-MM-DD HH:mm:ss"
        placeholder="结束时间"
        style="width: 100%"
      />
    </el-form-item>
    <el-form-item
      label="图片"
      prop="img"
      :rules="[{ required: true, message: '请上传图片' }]"
    >
      <el-upload
        class="upload-demo"
        style="width: 114px"
        :show-file-list="false"
        drag
        :headers="headers"
        :action="`${proxy.BASE_API_URL}index/upload`"
        :on-success="successUpload"
        :on-error="handleErr"
        :multiple="false"
      >
        <img v-if="proxy.IMG_BASE_URL + form.img" :src="form.img" class="avatar" />
        <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon
      ></el-upload>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { getCurrentInstance, nextTick, onMounted, ref } from "vue";
import { rolesEnums, eventStatusEnum } from "@/config/enums";
import { getTokenAUTH } from "@/utils/auth";

const form = ref({
  title: "",
  sort: "",
  is_event: "",
  discount: "",
  end_time: "",
  img: "",
});
const props = defineProps(["item"]);

const { proxy } = getCurrentInstance()

const headers = ref({})
onMounted(() => {
  headers.value['Accept-Token'] = getTokenAUTH()
  nextTick(() => {
    form.value = Object.assign(form, props.item);
    if(form.value.end_time > 0) {
      form.value.end_time = getTime(form.value.end_time)
    }
  });
});

const getTime = (time) => {
  if (time <= 0) {
    return "已过期";
  }
  const date = new Date(time * 1000);
  const formatPart = (num) => String(num).padStart(2, "0");
  return (
    [
      date.getFullYear(),
      formatPart(date.getMonth() + 1),
      formatPart(date.getDate()),
    ].join("-") +
    " " +
    [
      formatPart(date.getHours()),
      formatPart(date.getMinutes()),
      formatPart(date.getSeconds()),
    ].join(":")
  );
};

const successUpload = (res) => {
  form.value.img = res.data.url;
};

const handleErr = (err) => {
  if (err.status == 320) {
    form.value.img = JSON.parse(err.message).data.url;
  }
}

defineExpose({ form });
</script>

<style lang="less" scoped>
.demo-form-inline {
  justify-content: flex-start;
  display: flex;
  flex-wrap: wrap;
}
.demo-form-inline .el-input {
  --el-input-width: 220px;
}

.demo-form-inline .el-select {
  --el-select-width: 220px;
}
/deep/ .el-radio-group {
  width: 220px;
}
.form-title {
  text-align: left;
  padding-left: 30px;
  margin: 20px auto 10px;
  height: 44px;
  background-color: #f2f2f2;
  border-radius: 5px;
  line-height: 44px;
}
/deep/ .el-form-item {
  align-items: flex-start;
}
</style>
